/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Auth_Sso_Register_ErrorInputs */



/**
* | output |
* | --- |
* | "Registration with {provider} failed. Please try again." |
*
* @param {Auth_Sso_Register_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_register_error = /** @type {((inputs: Auth_Sso_Register_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_Register_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Registrierung mit ${i?.provider} fehlgeschlagen. Bitte versuche es erneut.`)
	return /** @type {LocalizedString} */ (`Registration with ${i?.provider} failed. Please try again.`)
});